import type { Bitmap } from "@brickme/project-core/src";
import { loadBitmapFromUrl } from "@brickme/project-core/src";
import type { EncodedImage } from "@brickme/project-core/src/utils/encoded-image.ts";

// Seems like it might be inefficient - we read it in to a url, then load that url.
// TODO: See if can use loadImage directly?
async function encodedImageArrayBufferToBitmap({
	buffer,
	mimeType,
}: EncodedImage): Promise<Bitmap> {
	const blob = new Blob([buffer as ArrayBuffer], { type: mimeType });
	const url = await new Promise<string>((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = ({ target }) => {
			if (!target) {
				reject(new Error("No target"));
				return;
			}
			const { result } = target;
			if (typeof result !== "string") {
				reject(new Error("Result is not a string"));
				return;
			}

			resolve(result);
		};
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
	return loadBitmapFromUrl(url);
}

export default encodedImageArrayBufferToBitmap;
